import CancelIcon from '@mui/icons-material/Cancel';
import { keyframes, styled } from "@mui/material";

const rotateCenter = keyframes`
0% {
  -webkit-transform: rotate(0);
          transform: rotate(0);
}
100% {
  -webkit-transform: rotate(360deg);
          transform: rotate(360deg);
}
`;

const CustomCancelIcon = styled(CancelIcon)(({ width, color }) => ({
  width: width || "25px",
  height: "auto",
  color: color || "#000",
  cursor: "pointer",
  "&:hover": {
    animation: `${rotateCenter} 0.6s ease-in-out both`,
    transition: "animation 1s linear",
  },
  "&:active": {
    animation: `${rotateCenter} 0.6s ease-in-out both`,
    transition: "animation 1s linear",
  },
  "&:focus": {
    animation: `${rotateCenter} 0.6s ease-in-out both`,
    transition: "animation 1s linear",
  },
}));

const CrossIcon = ({ color, width, ...otherProps }) => {
  return (
    <CustomCancelIcon
      width={width}
      color={color || "primary"}
      {...otherProps}
    />
  );
};

export default CrossIcon;
